export const ROLE_KEYS = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  OPERATOR: "operator",
  CUSTOMER_SERVICE: "customer_service",
  TECHNICAL: "technical",
};

export const ROLE_LABELS = {
  [ROLE_KEYS.SUPER_ADMIN]: "超管",
  [ROLE_KEYS.ADMIN]: "管理员",
  [ROLE_KEYS.OPERATOR]: "运营",
  [ROLE_KEYS.CUSTOMER_SERVICE]: "客服",
  [ROLE_KEYS.TECHNICAL]: "技术",
};

export const MENU_PERMISSION_KEYS = {
  DASHBOARD: "dashboard",
  MONITOR_CREATE_DASHBOARD: "monitor.createDashboard",
  MONITOR_ABANDON: "monitor.abandon",
  MONITOR_IMAGE_AUDIT: "monitor.imageAudit",
  CUSTOMERS_VERIFICATION: "customers.verification",
  CUSTOMERS_USERS: "customers.users",
  CUSTOMERS_AWARD_RISK_WHITELIST: "customers.awardRiskWhitelist",
  CUSTOMERS_ACTIVITIES: "customers.activities",
  CUSTOMERS_COMPLAINTS: "customers.complaints",
  ACTIVITIES_RECOMMENDATIONS: "activities.recommendations",
  ORDERS_ONLINE_PAYMENT: "orders.onlinePayment",
  MATERIALS_IMAGES: "materials.images",
  MATERIALS_LIBRARY: "materials.library",
  MATERIALS_TEMPLATES: "materials.templates",
  MATERIALS_HOME_BANNER: "materials.homeBanner",
  MATERIALS_PC_CMS: "materials.pcCms",
  CMS_MENU_LIST: "cms.menuList",
  CMS_ARTICLE_LIST: "cms.articleList",
  WELFARE_SCHEDULE: "welfare.schedule",
  WELFARE_PRODUCTS: "welfare.products",
  WELFARE_SPONSORS: "welfare.sponsors",
  RBAC: "system.rbac",
};

const MENU_ITEMS = [
  {
    section: "活动数据监控",
    items: [
      {
        label: "数据看板",
        path: "/admin/dashboard",
        icon: "fas fa-chart-line",
        permissionKey: MENU_PERMISSION_KEYS.DASHBOARD,
      },
      {
        label: "创建数据统计",
        path: "/admin/monitor/create-dashboard",
        icon: "fas fa-chart-pie",
        permissionKey: MENU_PERMISSION_KEYS.MONITOR_CREATE_DASHBOARD,
      },
      {
        label: "放弃创建",
        path: "/admin/monitor/abandon",
        icon: "fas fa-door-open",
        permissionKey: MENU_PERMISSION_KEYS.MONITOR_ABANDON,
      },
      {
        label: "图片审核",
        path: "/admin/monitor/image-audit",
        icon: "fas fa-image",
        permissionKey: MENU_PERMISSION_KEYS.MONITOR_IMAGE_AUDIT,
      },
    ],
  },
  {
    section: "客户管理",
    items: [
      {
        label: "认证申请",
        path: "/admin/customers/verification",
        activePaths: ["/admin/customers/verification"],
        icon: "fas fa-user-check",
        permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_VERIFICATION,
      },
      {
        label: "用户列表",
        path: "/admin/customers/users",
        icon: "fas fa-users",
        permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_USERS,
      },
      {
        label: "领奖风控白名单",
        path: "/admin/customers/award-risk-whitelist",
        icon: "fas fa-user-shield",
        permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_AWARD_RISK_WHITELIST,
      },
    ],
  },
  {
    section: "活动管理",
    items: [
      {
        label: "活动列表",
        path: "/admin/customers/activities",
        icon: "fas fa-calendar-alt",
        permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_ACTIVITIES,
      },
      {
        label: "推荐活动",
        path: "/admin/activities/recommendations",
        icon: "fas fa-bullhorn",
        permissionKey: MENU_PERMISSION_KEYS.ACTIVITIES_RECOMMENDATIONS,
      },
      {
        label: "活动投诉",
        path: "/admin/customers/complaints",
        icon: "fas fa-exclamation-triangle",
        permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_COMPLAINTS,
      },
    ],
  },
  {
    section: "订单",
    items: [
      {
        label: "线上支付订单",
        path: "/admin/orders/online-payment",
        icon: "fas fa-credit-card",
        permissionKey: MENU_PERMISSION_KEYS.ORDERS_ONLINE_PAYMENT,
      },
    ],
  },
  {
    section: "运营素材管理",
    items: [
      {
        label: "头图、奖品、背景",
        path: "/admin/materials/images",
        icon: "fas fa-images",
        permissionKey: MENU_PERMISSION_KEYS.MATERIALS_IMAGES,
      },
      {
        label: "素材库",
        path: "/admin/materials/library",
        icon: "fas fa-folder-open",
        permissionKey: MENU_PERMISSION_KEYS.MATERIALS_LIBRARY,
      },
      {
        label: "活动模版",
        path: "/admin/materials/templates",
        icon: "fas fa-layer-group",
        permissionKey: MENU_PERMISSION_KEYS.MATERIALS_TEMPLATES,
      },
      {
        label: "首页 Banner",
        path: "/admin/materials/home-banner",
        icon: "fas fa-image",
        permissionKey: MENU_PERMISSION_KEYS.MATERIALS_HOME_BANNER,
      },
    ],
  },
  {
    section: "CMS",
    items: [
      {
        label: "菜单列表",
        path: "/admin/cms/menus",
        icon: "fas fa-bars",
        permissionKey: MENU_PERMISSION_KEYS.CMS_MENU_LIST,
      },
      {
        label: "文章列表",
        path: "/admin/cms/articles",
        icon: "fas fa-file-alt",
        permissionKey: MENU_PERMISSION_KEYS.CMS_ARTICLE_LIST,
      },
    ],
  },
  {
    section: "官方每日福利",
    items: [
      {
        label: "活动排期",
        path: "/admin/welfare/schedule",
        icon: "fas fa-calendar-check",
        permissionKey: MENU_PERMISSION_KEYS.WELFARE_SCHEDULE,
      },
      {
        label: "商品管理",
        path: "/admin/welfare/products",
        icon: "fas fa-gift",
        permissionKey: MENU_PERMISSION_KEYS.WELFARE_PRODUCTS,
      },
      {
        label: "赞助商管理",
        path: "/admin/welfare/sponsors",
        icon: "fas fa-handshake",
        permissionKey: MENU_PERMISSION_KEYS.WELFARE_SPONSORS,
      },
    ],
  },
  {
    section: "系统管理",
    items: [
      {
        label: "权限管理",
        path: "/admin/rbac",
        icon: "fas fa-user-shield",
        permissionKey: MENU_PERMISSION_KEYS.RBAC,
      },
    ],
  },
];

const API_PERMISSION_RULES = [
  { method: "POST", path: "/picture", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_IMAGES, action: "editable" },
  { method: "PUT", path: "/picture", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_IMAGES, action: "editable" },
  { method: "DELETE", path: "/picture", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_IMAGES, action: "editable" },
  { method: "POST", path: "/picture/show", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_IMAGES, action: "editable" },
  { method: "POST", path: "/template/cate", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_TEMPLATES, action: "editable" },
  { method: "PUT", path: "/template/cate", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_TEMPLATES, action: "editable" },
  { method: "DELETE", path: "/template/cate", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_TEMPLATES, action: "editable" },
  { method: "POST", path: "/template/cate/show", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_TEMPLATES, action: "editable" },
  { method: "POST", path: "/template", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_TEMPLATES, action: "editable" },
  { method: "PUT", path: "/template", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_TEMPLATES, action: "editable" },
  { method: "DELETE", path: "/template", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_TEMPLATES, action: "editable" },
  { method: "POST", path: "/template/show", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_TEMPLATES, action: "editable" },
  { method: "POST", path: "/home/banner", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_HOME_BANNER, action: "editable" },
  { method: "PUT", path: "/home/banner", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_HOME_BANNER, action: "editable" },
  { method: "DELETE", path: "/home/banner", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_HOME_BANNER, action: "editable" },
  { method: "POST", path: "/home/banner/publish", permissionKey: MENU_PERMISSION_KEYS.MATERIALS_HOME_BANNER, action: "editable" },
  { method: "POST", path: "/pc/cms/menu", permissionKey: MENU_PERMISSION_KEYS.CMS_MENU_LIST, action: "editable" },
  { method: "PUT", path: "/pc/cms/menu", permissionKey: MENU_PERMISSION_KEYS.CMS_MENU_LIST, action: "editable" },
  { method: "DELETE", path: "/pc/cms/menu", permissionKey: MENU_PERMISSION_KEYS.CMS_MENU_LIST, action: "editable" },
  { method: "POST", path: "/pc/cms", permissionKey: MENU_PERMISSION_KEYS.CMS_ARTICLE_LIST, action: "editable" },
  { method: "PUT", path: "/pc/cms", permissionKey: MENU_PERMISSION_KEYS.CMS_ARTICLE_LIST, action: "editable" },
  { method: "DELETE", path: "/pc/cms", permissionKey: MENU_PERMISSION_KEYS.CMS_ARTICLE_LIST, action: "editable" },
  { method: "POST", path: "/pc/cms/publish", permissionKey: MENU_PERMISSION_KEYS.CMS_ARTICLE_LIST, action: "editable" },
  { method: "POST", path: "/task/index/goods", permissionKey: MENU_PERMISSION_KEYS.WELFARE_PRODUCTS, action: "editable" },
  { method: "PUT", path: "/task/index/goods", permissionKey: MENU_PERMISSION_KEYS.WELFARE_PRODUCTS, action: "editable" },
  { method: "DELETE", path: "/task/index/goods", permissionKey: MENU_PERMISSION_KEYS.WELFARE_PRODUCTS, action: "editable" },
  { method: "POST", path: "/task/index/schedule", permissionKey: MENU_PERMISSION_KEYS.WELFARE_SCHEDULE, action: "editable" },
  { method: "PUT", path: "/task/index/schedule", permissionKey: MENU_PERMISSION_KEYS.WELFARE_SCHEDULE, action: "editable" },
  { method: "DELETE", path: "/task/index/schedule", permissionKey: MENU_PERMISSION_KEYS.WELFARE_SCHEDULE, action: "editable" },
  { method: "POST", path: "/auth/audit", permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_VERIFICATION, action: "editable" },
  { method: "POST", path: "/complaint", permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_COMPLAINTS, action: "editable" },
  { method: "POST", path: "/user/ban", permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_USERS, action: "editable" },
  { method: "POST", path: "/user/award-risk-whitelist", permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_AWARD_RISK_WHITELIST, action: "editable" },
  { method: "DELETE", path: "/user/award-risk-whitelist", permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_AWARD_RISK_WHITELIST, action: "editable" },
  { method: "POST", path: "/task/ban", permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_ACTIVITIES, action: "editable" },
  { method: "POST", path: "/task/template", permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_ACTIVITIES, action: "editable" },
  { method: "PUT", path: "/task/tags", permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_ACTIVITIES, action: "editable" },
  { method: "POST", path: "/task/openapi/trial", permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_ACTIVITIES, action: "editable" },
  { method: "PUT", path: "/task/image-audit/review", permissionKey: MENU_PERMISSION_KEYS.MONITOR_IMAGE_AUDIT, action: "editable" },
  { method: "POST", path: "/task/image-audit/manual-check", permissionKey: MENU_PERMISSION_KEYS.MONITOR_IMAGE_AUDIT, action: "editable" },
];

const LEGACY_PERMISSION_FALLBACK = {
  [MENU_PERMISSION_KEYS.CMS_MENU_LIST]: MENU_PERMISSION_KEYS.MATERIALS_PC_CMS,
  [MENU_PERMISSION_KEYS.CMS_ARTICLE_LIST]: MENU_PERMISSION_KEYS.MATERIALS_PC_CMS,
};

function permission(visible, editable) {
  return { visible, editable };
}

function buildPermissions(visibleKeys, editableKeys = visibleKeys) {
  return Object.values(MENU_PERMISSION_KEYS).reduce((result, key) => {
    const visible = visibleKeys.includes(key);
    result[key] = permission(visible, visible && editableKeys.includes(key));
    return result;
  }, {});
}

const allPermissionKeys = Object.values(MENU_PERMISSION_KEYS);
const customerServiceKeys = [
  MENU_PERMISSION_KEYS.DASHBOARD,
  MENU_PERMISSION_KEYS.MONITOR_CREATE_DASHBOARD,
  MENU_PERMISSION_KEYS.CUSTOMERS_VERIFICATION,
  MENU_PERMISSION_KEYS.CUSTOMERS_USERS,
  MENU_PERMISSION_KEYS.CUSTOMERS_ACTIVITIES,
  MENU_PERMISSION_KEYS.ACTIVITIES_RECOMMENDATIONS,
  MENU_PERMISSION_KEYS.CUSTOMERS_COMPLAINTS,
  MENU_PERMISSION_KEYS.ORDERS_ONLINE_PAYMENT,
];
const operatorKeys = [
  MENU_PERMISSION_KEYS.DASHBOARD,
  MENU_PERMISSION_KEYS.MONITOR_CREATE_DASHBOARD,
  MENU_PERMISSION_KEYS.CUSTOMERS_ACTIVITIES,
  MENU_PERMISSION_KEYS.ACTIVITIES_RECOMMENDATIONS,
  MENU_PERMISSION_KEYS.CUSTOMERS_AWARD_RISK_WHITELIST,
  MENU_PERMISSION_KEYS.MATERIALS_IMAGES,
  MENU_PERMISSION_KEYS.MATERIALS_LIBRARY,
  MENU_PERMISSION_KEYS.MATERIALS_TEMPLATES,
  MENU_PERMISSION_KEYS.MATERIALS_HOME_BANNER,
  MENU_PERMISSION_KEYS.MATERIALS_PC_CMS,
  MENU_PERMISSION_KEYS.CMS_MENU_LIST,
  MENU_PERMISSION_KEYS.CMS_ARTICLE_LIST,
  MENU_PERMISSION_KEYS.WELFARE_SCHEDULE,
  MENU_PERMISSION_KEYS.WELFARE_PRODUCTS,
  MENU_PERMISSION_KEYS.WELFARE_SPONSORS,
];
const technicalKeys = [
  MENU_PERMISSION_KEYS.DASHBOARD,
  MENU_PERMISSION_KEYS.MONITOR_CREATE_DASHBOARD,
  MENU_PERMISSION_KEYS.MONITOR_ABANDON,
  MENU_PERMISSION_KEYS.CUSTOMERS_USERS,
  MENU_PERMISSION_KEYS.CUSTOMERS_ACTIVITIES,
  MENU_PERMISSION_KEYS.ACTIVITIES_RECOMMENDATIONS,
];

const DEFAULT_ROLE_PERMISSIONS = {
  [ROLE_KEYS.SUPER_ADMIN]: buildPermissions(allPermissionKeys),
  [ROLE_KEYS.ADMIN]: buildPermissions(allPermissionKeys.filter((key) => {
    return key !== MENU_PERMISSION_KEYS.RBAC;
  })),
  [ROLE_KEYS.OPERATOR]: buildPermissions(operatorKeys),
  [ROLE_KEYS.CUSTOMER_SERVICE]: buildPermissions(customerServiceKeys),
  [ROLE_KEYS.TECHNICAL]: buildPermissions(technicalKeys, [
    MENU_PERMISSION_KEYS.MONITOR_CREATE_DASHBOARD,
    MENU_PERMISSION_KEYS.MONITOR_ABANDON,
    MENU_PERMISSION_KEYS.CUSTOMERS_USERS,
    MENU_PERMISSION_KEYS.CUSTOMERS_ACTIVITIES,
    MENU_PERMISSION_KEYS.ACTIVITIES_RECOMMENDATIONS,
  ]),
};

function normalizeRole(role) {
  return role || ROLE_KEYS.ADMIN;
}

function normalizePermissionEntry(entry) {
  if (entry === true) {
    return permission(true, true);
  }
  if (entry === false) {
    return permission(false, false);
  }

  return permission(Boolean(entry?.visible), Boolean(entry?.editable));
}

function normalizeBackendPermissions(permissions) {
  if (!permissions || typeof permissions !== "object") {
    return {};
  }

  return Object.entries(permissions).reduce((result, [key, entry]) => {
    result[key] = normalizePermissionEntry(entry);
    return result;
  }, {});
}

export function getRolePermissions(role) {
  return {
    ...(DEFAULT_ROLE_PERMISSIONS[normalizeRole(role)] || DEFAULT_ROLE_PERMISSIONS[ROLE_KEYS.ADMIN]),
  };
}

export function getUserPermissions(userInfo) {
  const basePermissions = getRolePermissions(userInfo?.role);
  const backendPermissions = normalizeBackendPermissions(userInfo?.permissions);

  return {
    ...basePermissions,
    ...backendPermissions,
  };
}

export function hasPermission(userInfo, permissionKey, action = "visible") {
  if (!permissionKey) {
    return true;
  }
  if (userInfo?.role === ROLE_KEYS.SUPER_ADMIN) {
    return true;
  }

  const permissionEntry = getUserPermissions(userInfo)[permissionKey];
  if (permissionEntry && permissionEntry[action]) {
    return true;
  }

  const legacyPermissionKey = LEGACY_PERMISSION_FALLBACK[permissionKey];
  if (!legacyPermissionKey) {
    return false;
  }
  const legacyPermissionEntry = getUserPermissions(userInfo)[legacyPermissionKey];
  return Boolean(legacyPermissionEntry && legacyPermissionEntry[action]);
}

export function canEdit(userInfo, permissionKey) {
  return hasPermission(userInfo, permissionKey, "editable");
}

export function canAccessRoute(userInfo, permissionKey) {
  return hasPermission(userInfo, permissionKey, "visible");
}

export function getMenuConfig() {
  return MENU_ITEMS;
}

export function getFlatMenuItems() {
  return MENU_ITEMS.flatMap((group) => {
    return group.items.map((item) => ({
      ...item,
      section: group.section,
    }));
  });
}

export function getVisibleMenuConfig(userInfo) {
  return MENU_ITEMS.map((group) => ({
    ...group,
    items: group.items.filter((item) => hasPermission(userInfo, item.permissionKey, "visible")),
  })).filter((group) => group.items.length > 0);
}

export function getFirstAccessibleAdminPath(userInfo) {
  for (const group of MENU_ITEMS) {
    for (const item of group.items) {
      if (hasPermission(userInfo, item.permissionKey, "visible")) {
        return item.path;
      }
    }
  }

  return "/";
}

export function findApiPermission(url, method = "GET") {
  const requestMethod = method.toUpperCase();
  const pathname = getPathname(url);

  return API_PERMISSION_RULES.find((rule) => {
    return requestMethod === rule.method && pathname.endsWith(rule.path);
  });
}

function getPathname(url) {
  try {
    return new URL(url, window?.location?.origin || "https://api.52choujiang.cn").pathname;
  } catch (error) {
    return String(url || "");
  }
}
